export default __webpack_public_path__ + "static/media/laundry1-afterA-1440w.271f6500.webp";